import React, { Component } from "react";

import { Button } from "@revvsales/components";
import APPROVE from "../../../../assets/Approve-Icon.png";

import { GlobalUtils } from "../../../../utils/index";

// Declarations
const { readDataFromLocalStorage } = GlobalUtils;

class QuotationBottomStages extends Component {
  state = {};

  render() {
    const CURRENT_USER = readDataFromLocalStorage("revvsalesUser");
    let bannerHeader = "";
    if (
      this.props.docStage === "SENT" &&
      this.props.docOwnerID === CURRENT_USER.id
    ) {
      bannerHeader =
        "You added yourself as an Acceptor. You can Accept or Reject as needed. The document will be completed once all recipients added as Acceptors take an action.";
    } else if (this.props.docStage === "SENT") {
      bannerHeader =
        "Please review this document and Accept or Reject as required.";
    } else {
      bannerHeader =
        "Please review this document and Approve or Reject as required.";
    }
    return (
      <div className="quotationbar-options">
        <div className="quotationbar-options-wrapper">
          <div>
            <img src={APPROVE} alt="Revv" className="bottom-banner-icon" />
          </div>
          <div className="bottom-banner-title">
            {/* <div className="bottom-banner-header">
              Your document requires your approval
            </div> */}
            <div className="bottom-banner-subheader">{bannerHeader}</div>
          </div>
          <div className="bottom-banner-buttons">
            <Button
              className="approve-document"
              onClick={() => this.props.togglePopUp("Approve", true)}
              id={"Approve".replace(/ +/g, "-").toLowerCase()}
              data-test="quotationTopbar-upgrade-stage-btn">
              {this.props.docStage === "SENT" ? "Accept" : "Approve"}
            </Button>
          </div>
          <div className="bottom-banner-buttons-diff">
            <Button
              className="reject-document"
              onClick={() => this.props.togglePopUp("Reject", true)}
              id={"Reject".replace(/ +/g, "-").toLowerCase()}
              data-test="quotationTopbar-upgrade-stage-btn">
              Reject
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
export default QuotationBottomStages;



// WEBPACK FOOTER //
// ./src/components/QuotationTopbar/QuotationBottomBar/QuotationBottomStages/index.js